import apiClient from './client'
import type { AttendanceStatus, GroupJournal, SessionBoard } from '../../../shared/src/types/api'

export const trainingSessionsApi = {
  peek: async (groupId: string, date: string, startTime?: string): Promise<SessionBoard> => {
    const { data } = await apiClient.get('/training-sessions/board', {
      params: { group_id: groupId, date, start_time: startTime || undefined },
    })
    return data
  },
  resolve: async (assistantId: string, groupId: string, date: string, startTime?: string): Promise<SessionBoard> => {
    const { data } = await apiClient.post('/training-sessions/resolve', {
      assistant_id: assistantId, group_id: groupId, date, start_time: startTime || undefined,
    })
    return data
  },
  mark: async (sessionId: string, athleteId: string, status: AttendanceStatus, notes?: string): Promise<SessionBoard> => {
    const { data } = await apiClient.post(`/training-sessions/${sessionId}/marks`, { athlete_id: athleteId, status, notes })
    return data
  },
  unmark: async (sessionId: string, athleteId: string): Promise<SessionBoard> => {
    const { data } = await apiClient.delete(`/training-sessions/${sessionId}/marks/${athleteId}`)
    return data
  },
  journal: async (groupId: string, from: string, to: string): Promise<GroupJournal> => {
    const { data } = await apiClient.get(`/groups/${groupId}/attendance/journal`, { params: { from, to } })
    return data
  },
}
